import { Hero1 } from "@/components/ui/hero-1";
import { useHomeData } from '../../hooks/useHomeData';

export const HomeHeroSection = () => {
  const { hero } = useHomeData();

  return (
    <div className="hero-section-spacing">
      <Hero1
        heading={hero.heading}
        description={hero.description}
        image={hero.image}
      />
    </div>
  );
};
